import { CurveDirection } from '@statsbomb/kitbag-datavis';
import { EventCornerTechnique } from '@statsbomb/parachute-types';

const PITCH_MID_X = 60;
const PITCH_MID_Y = 40;

export const getCornerCurveDirection = (
  startX: number,
  startY: number,
  technique: EventCornerTechnique,
): CurveDirection | undefined => {
  if (technique === 'straight') return undefined;
  const inswing: CurveDirection = startX < PITCH_MID_X === startY < PITCH_MID_Y ? 'right' : 'left';
  if (technique === 'inswinging') return inswing;
  return inswing === 'right' ? 'left' : 'right';
};
